/**
 * @generated SignedSource<<5f92ebba0a0609f2ff910f0ace73aec5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCurrentClubSlug_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly slug: string;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentClubSlug_session";
};
export type useCurrentClubSlug_session$key = {
  readonly " $data"?: useCurrentClubSlug_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentClubSlug_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentClubSlug_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "b79457213e2c84adec206778b9d5ee6f";

export default node;
